
import { createI18n } from "vue-i18n";
import zhHk from "./language/zh-hk";
import zhSim from "./language/zh-sim";
import en from './language/en'
import ar from "./language/ar";
import id from "./language/id";
import ja from "./language/ja";
import th from "./language/th";
import vi from "./language/vi";
import { handleQueryParams } from '@/utils/common'

const queryParams: any = handleQueryParams()

// 默认语言
const defaultLocale = () => {
    const languageMap: Record<number | string, string> = {
        0: 'zhSim', // 简体中文  
        1: 'en',      // 英语  
        2: 'zhHk', // 繁体中文（同 0）  
        3: 'th',      // 泰语  
        4: 'ja',      // 日语  
        5: 'id',      // 印尼文  
        7: 'ar',      // 阿语  
        8: 'vi'       // 越南语  
    };
    return languageMap[queryParams.lang];
}

const i18n = createI18n({
    locale: defaultLocale(),
    legacy: false,
    messages: { zhSim, en, zhHk, ar, id, ja, th, vi }
})

export default i18n
